/* eslint-disable react/no-danger */
import React, { PureComponent } from 'react';
import _ from 'lodash';
import { Button } from 'react-bootstrap/lib';
import '../ReactModal/reactModal.scss';

class ValidateModal extends PureComponent {
  constructor() {
    super();
    this.state = {
      isOpen: false,
      importDealerRun: null,
    };
  }

  // FIXME: refactor to use a prop rather than calling this method through a ref
  // eslint-disable-next-line react/no-unused-class-component-methods
  open = (importDealerRun) => {
    this.setState({ isOpen: true, importDealerRun });
  };

  close = () => this.setState({ isOpen: false });

  render() {
    const run = this.state.importDealerRun;
    if (!run) return null;
    const hasErrors = Object.values(run.stats.errors).some(
      (errors) => !_.isEmpty(errors),
    );
    const cpoCarsCount = (carsCount) =>
      carsCount.CPOCars >= 0 ? carsCount.CPOCars : 'N/A';
    return this.state.isOpen ? (
      <div className="p-modal-container">
        <div className="p-modal">
          <div className="p-modal-text">
            <p>
              <h2>Import Stats</h2>
            </p>
            <hr />
            <p>
              <small>
                Total cars found in feed: {run.stats.carsCount.totalCars}
              </small>
            </p>
            <p>
              <small>
                Actual cars imported: {run.stats.incrementable.carsImported}
              </small>
            </p>

            <hr />
            <p>
              <small>
                New cars: {run.stats.carsCount.newCars} - Used:{' '}
                {run.stats.carsCount.usedCars} - Sold:{' '}
                {run.stats.carsCount.soldCars} - CPO:{' '}
                {cpoCarsCount(run.stats.carsCount)}
              </small>
            </p>
            <hr />
            <p>
              <small>
                Successful Cached ChromeData Decode:{' '}
                {run.stats.incrementable.successfulCachedChromeDataDecodeCount}
              </small>
            </p>
            <p>
              <small>
                Successful Fresh ChromeData Decode:{' '}
                {run.stats.incrementable.successfulFreshChromeDataDecodeCount}
              </small>
            </p>
            <p>
              <small>
                Successful ChromeData Incentives:{' '}
                {run.stats.incrementable.successfulChromeDataIncentivesCount}
              </small>
            </p>
            <p>
              <small>
                Successful AIS Incentives:{' '}
                {run.stats.incrementable.successfulAISIncentivesCount}
              </small>
            </p>
            <p>
              <small>
                Successful Shift Retrievals:{' '}
                {run.stats.incrementable.successfulShiftCount}
              </small>
            </p>
            {hasErrors && (
              <div>
                <hr />
                <p>
                  Errors -{' '}
                  <Button
                    onClick={() => {
                      document.getElementById('errorstext').select();
                      document.execCommand('copy');
                    }}
                  >
                    Copy errors to Clipboard
                  </Button>
                </p>
                <textarea
                  cols="80"
                  rows="4"
                  id="errorstext"
                  style={{ fontSize: '10px' }}
                  value={JSON.stringify(run.stats.errors, null, 2)}
                />
              </div>
            )}
          </div>

          <i
            onClick={this.close}
            className="modal-close close icon"
            alt="close"
          />
        </div>
      </div>
    ) : null;
  }
}

export default ValidateModal;
